import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const VideoJi = ({ width = '27px', height = '27px', className, ...rest }: Props) => (
  <svg
    className={className}
    height={height}
    width={width}
    fill="none"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <rect height="100px" width="100px" rx="8" fill="#17D5FF" />
    <path
      d="M69.8333 50.0007C69.8333 51.0084 69.2981 51.9403 68.4276 52.448L34.4276 72.2814C33.5513 72.7925 32.4686 72.7962 31.5888 72.2909C30.7091 71.7856 30.1667 70.8485 30.1667 69.834V30.1673C30.1667 29.1528 30.7091 28.2157 31.5888 27.7104C32.4686 27.2051 33.5513 27.2088 34.4276 27.7199L68.4276 47.5533C69.2981 48.061 69.8333 48.9929 69.8333 50.0007Z"
      fill="#11191D"
    />
  </svg>
);

export default VideoJi;
